import local from "./local-models-got-good";
import stillLearn from "./should-you-still-learn-to-code";
import fable from "./what-claude-fable-5-means-for-learners";

export type BlogContent = {
  title: string;
  excerpt: string;
  /** Trusted HTML authored in this repo, rendered into .ss-prose. */
  body: string;
};

const content: Record<string, BlogContent> = {
  "what-claude-fable-5-means-for-learners": fable,
  "local-models-got-good": local,
  "should-you-still-learn-to-code": stillLearn,
};

export default content;
